import React from 'react';
import { Gallery, Section, SectionSubTitle } from 'common/components';
import { getFencesGalleryList } from './fences-gallery-section-utils';
import { FencesMainPageType } from '../../fences-types';
import { fencesGallerySectionGrid } from './fences-gallery-section-styles';

type FencesGallerySectionProps = {
  elementBlock: string;
  onConsultationSignupBtnClick: () => void;
  mainPageType: FencesMainPageType;
  fencesType?: string;
};

export const FencesGallerySection: React.FC<FencesGallerySectionProps> = ({
  elementBlock,
  onConsultationSignupBtnClick,
  mainPageType,
  fencesType = '',
}) => {
  const galleryList = getFencesGalleryList(fencesType, mainPageType);

  return (
    <Section>
      <SectionSubTitle margin="m">Выполненные работы</SectionSubTitle>
      <Gallery
        elementBlock={elementBlock}
        elementText="Выполненные работы"
        galleryGridClassName={fencesGallerySectionGrid}
        imageList={galleryList}
        imagePerPage={5}
        initialImagePerPage={7}
        isShowImageName
        modalBtnProps={{ onClick: onConsultationSignupBtnClick }}
      />
    </Section>
  );
};
